import { format } from 'd3-format';
import { timeFormat } from 'd3-time-format';

// Colors matching the app's dark theme
export const colors = {
  candleUp: '#22c55e',
  candleDown: '#ef4444',
  candleUpFill: '#22c55e',
  candleDownFill: '#1f2937',
  volume: 'rgba(34, 197, 94, 0.25)',
  axis: '#9ca3af',
  grid: '#374151',
  crosshair: '#6b7280',
  background: 'transparent',
  boundUpper: '#ef4444',
  boundLower: '#22c55e',
  gridLevel: '#666666',
  tradeBuy: '#22c55e',
  tradeSell: '#ef4444',
  tooltipLabel: '#9ca3af',
  tooltipValue: '#e5e7eb',
};

export const chartMargin = { left: 0, right: 56, top: 8, bottom: 4 };

export const priceFormat = format('.2f');
export const volumeFormat = format('.2s');
export const dateFormat = timeFormat('%b %d');
export const timeFormatShort = timeFormat('%H:%M');
export const dateTimeFormat = timeFormat('%b %d %H:%M');
